import { SearchQueryStrings } from "@graylog/server-api";
const recordQueryStringUsage = async (newQuery, oldQuery) => {
  if (newQuery && newQuery !== oldQuery) {
    try {
      await SearchQueryStrings.queryStringUsed({ query_string: newQuery });
    } catch (error) {
      console.error("Unable to record last used query string: ", error);
    }
  }
};
export default recordQueryStringUsage;
